import { untilBrowserTabVisible } from "@/utils/dom/dom";

import { addBreadcrumb, captureMessage } from "./sentry";

let reloadAt = 0;

export function isReloading() {
  // after 5s of reloading, assume it failed so that errors are logged again
  const r = reloadingFor();
  return r >= 0 && r < 5000;
}

export function reloadingFor() {
  return reloadAt ? Date.now() - reloadAt : -1;
}

type ReloadReason =
  | "connection-closed"
  | "refresh-token"
  | "reconnect-fail"
  | "dynamic-import-error"
  | "manual-global-error"
  | "manual-connection-status";

export function reload(reason: ReloadReason) {
  const url = new URL(window.location.href);

  const hashUrl = new URL(url.hash.slice(1), window.location.origin);
  hashUrl.searchParams.set("reload", reason);
  url.hash = hashUrl.pathname + hashUrl.search;

  // Replace current history entry (no navigation event triggered)
  window.history.replaceState(window.history.state, "", url.toString());
  addBreadcrumb("navigation", {
    message: `Reload page for reason: ${reason}`,
    data: { url: url.toString() },
  });

  // Now perform exactly one navigation: the hard reload
  reloadAt = Date.now();
  void trackReload();
  window.location.reload();
}

async function trackReload() {
  const wasVisible = await untilBrowserTabVisible().promise;
  if (!wasVisible) {
    reloadAt = Date.now();
  }
  setTimeout(wasNotReloaded, 5000);
}

function wasNotReloaded() {
  const elapsed = Date.now() - reloadAt;
  captureMessage("Page was not reloaded", { info: { elapsed } });
  // give up after 20s
  if (elapsed < 20_000) {
    void trackReload();
  }
}
